/* Copyright (c) 2017 Backpack Health LLC */

import { authorizedApiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';
import AttachmentModel from '../models/AttachmentModel';

const AttachmentsApi = {
  create(profileId) {
    return authorizedApiRequest('post', `profiles/${profileId}/attachments`);
  },

  getAll(profileId) {
    return authorizedApiRequest('get', `profiles/${profileId}/attachments`);
  },

  get(profileId, attachmentId) {
    return authorizedApiRequest('get', `profiles/${profileId}/attachments/${attachmentId}`);
  },

  del(profileId, attachmentId) {
    return authorizedApiRequest('delete', `profiles/${profileId}/attachments/${attachmentId}`);
  },
};

const AttachmentsService = {

  create(profileId, attachmentData, callback) {
    return AttachmentsApi.create(profileId)
      .send(attachmentData)
      .then((res) => {
        const newAttachment = new AttachmentModel(res.body.data);
        if (callback) {
          callback(null, newAttachment)
        }
        return newAttachment;
      })
      .catch(err => {
        const apiError = err ? new ApiErrorModel(err) : null;

        if (callback) {
          callback(apiError)
        }

        throw apiError;
      });
  },

  getAll(profileId, callback) {
    return AttachmentsApi.getAll(profileId)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        const attachmentsCollection = apiError ? [] : res.body.data;
        callback(apiError, attachmentsCollection);
      });
  },

  getAllForParent(profileId, parentType, parentId) {
    return authorizedApiRequest(
      'get',
      `profiles/${profileId}/attachments?parentType=${parentType}&parentId=${parentId}`
      ).then((res) => {
        return res.body.data;
      });
  },

  del(profileId, attachmentId, callback) {
    return AttachmentsApi.del(profileId, attachmentId)
      .end((err) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, null);
      });
  },

};

export default AttachmentsService;
